import { getConfig } from 'utils/config';

import { educatiusBranding } from './educatius';
import { enrollerBranding } from './enroller';

const { brandOrganisation } = getConfig();

export const branding = brandOrganisation === 'educatius' ? educatiusBranding : enrollerBranding;
